module.exports = __webpack_public_path__ + "static/wnp-icon-2-763b3dd7ff68c038e1aa8366d2a4244a.svg";